export default "__VITE_ASSET__JEvpkJoR__"